// import request from '@/utils/request'
import request from '@/utils/request'
// 公钥
export function kluczPubliczny(data) {
  return request({
    url: '/get/publicKey',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 验证码
export function verificationCode(data) {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false,
      'Cache-Control': 'no-cache'
    },
    method: 'get',
    data: data,
  })
}

// 登录
export function loginID(data) {
  return request({
    url: '/foreground/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 退出系统
export function loginout(data) {
  return request({
    url: '/logout',
    // headers: {
    //   isToken: false
    // },
    method: 'get',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js